<script>
    import Button from '$lib/components/Button.svelte';
</script>

<div class="m-auto max-w-sm text-center">
    <h1 class="text-2xl font-semibold dark:text-purple-300">Product not found</h1>
    <p class="py-7 text-lg">The product you are looking for doesn't exists.</p>
    <Button style="Primary" href="/">Go Home</Button>
</div>
